import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DefaultLayout from './components/DefaultLayout';
import AboutUs from './components/AboutUs';
import Home from './components/Home';
import NotFound from './components/NotFound';
import OurService from './components/OurService';
import TechSpecs from './components/TechSpecs';

export default function App() {

  return (
    <Router>
      <Routes>
        <Route element={<DefaultLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/our-service" element={<OurService />} />
          <Route path="/tech-specs" element={<TechSpecs />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}